import { render } from "./ProfileWrapper.vue.js?vue&type=template&id=5f1bf7bb&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ProfileWrapper.vue?vue&type=template&id=5f1bf7bb&scoped=true"
import script from "./ProfileWrapper.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ProfileWrapper.vue?vue&type=script&lang=js"
export * from "./ProfileWrapper.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ProfileWrapper.vue?vue&type=script&lang=js"

import "./ProfileWrapper.vue.scss?vue&type=style&index=0&id=5f1bf7bb&lang=scss&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ProfileWrapper.vue?vue&type=style&index=0&id=5f1bf7bb&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f1bf7bb"],['__file',"src/Web/scripts/components/publication/ProfileWrapper.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5f1bf7bb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5f1bf7bb', __exports__)) {
    api.reload('5f1bf7bb', __exports__)
  }
  
  module.hot.accept("./ProfileWrapper.vue.js?vue&type=template&id=5f1bf7bb&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ProfileWrapper.vue?vue&type=template&id=5f1bf7bb&scoped=true", () => {
    api.rerender('5f1bf7bb', render)
  })

}


export default __exports__